import axios from 'axios'

const api = {

  // login

  async verify (phone) {
    return axios.post('/api/verify', { phone })
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  //

  async getPharmacies () {
    return axios.get('/api/st/pharmacies').then(response => response.data)
  },

  async getPharmacy (pharmacyId) {
    return axios.get('/api/st/pharmacies/' + pharmacyId).then(response => response.data)
  },

  async getWishes () {
    return axios.get('/api/st/wishes').then(response => response.data)
  },

  async createWish (wish) {
    return axios.post('/api/st/wishes', wish).then(response => response.data)
  },

  async createWishes (pharmacyIds) {
    return axios.post('/api/st/wishes', pharmacyIds).then(response => response.data)
  },

  async updateWishesOrder (pharmacyIds) {
    return axios.post('/api/st/wishes/order', pharmacyIds).then(response => response.data)
  },

  async deleteWish (id) {
    return axios.delete(`/api/st/wishes/${id}`).then(response => response.data)
  },

  // election period

  async getElectionPeriod () {
    return await axios.get('/api/st/electionperiods/active').then(response => response.data)
  },

  // practice slot

  async getAssignedPracticeSlot () {
    return await axios.get('/api/st/practiceslots/assigned').then(response => response.data)
  },

  // university

  async getUniversity () {
    return await axios.get('/api/st/university').then(response => response.data)
  }

}

export default api